<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR PROCESSO DE INSCRIÇÃO' : 'NOVO PROCESSO DE INSCRIÇÃO'" titleIcon="fas fa-clipboard-list">

            <div v-if="!carregado" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

            <el-tabs v-else v-model="aba">

                <el-tab-pane label="Diretrizes" name="diretrizes">
                    <el-form label-position="top" :model="dados" ref="dados">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="10">
                                <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                                    <el-input v-model="dados.nome" maxlength="191"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="7">
                                <el-form-item label="Tipo" prop="tipo" :rules="[$requiredChange]">
                                    <el-select v-model="dados.tipo" style="width: 100%;">
                                        <el-option value="inscricao_matricula" label="Inscrição para matrícula"></el-option>
                                        <el-option value="lista_espera" label="Lista de espera"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="7">
                                <el-form-item label="Período letivo" prop="periodo_letivo_id" :rules="[$requiredChange]">
                                    <el-select v-model="dados.periodo_letivo_id" style="width: 100%;">
                                        <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="12" :sm="5">
                                <el-form-item label="Início das inscrições">
                                    <el-date-picker v-model="dados.data_inicio" type="date" value-format="yyyy-MM-dd"
                                        format="dd/MM/yyyy" style="width: 100%;"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="5">
                                <el-form-item label="Fim das inscrições">
                                    <el-date-picker v-model="dados.data_fim" type="date" value-format="yyyy-MM-dd"
                                        format="dd/MM/yyyy" style="width: 100%;"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="5">
                                <el-form-item label="Escolas por candidato">
                                    <el-input v-model="dados.qtd_max_estabelecimentos" v-mask="'##'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="4">
                                <el-form-item label="Canal">
                                    <el-select v-model="dados.canal" style="width: 100%;">
                                        <el-option value="ambos" label="Ambos"></el-option>
                                        <el-option value="presencial" label="Presencial"></el-option>
                                        <el-option value="online" label="Online"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="5">
                                <el-form-item label="Situação">
                                    <el-select v-model="dados.situacao" style="width: 100%;">
                                        <el-option :value="true" label="Ativo"></el-option>
                                        <el-option :value="false" label="Inativo"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="12" :sm="6">
                                <el-form-item label="Publica o resultado?">
                                    <el-select v-model="dados.publica_resultado" style="width: 100%;">
                                        <el-option :value="true" label="Sim"></el-option>
                                        <el-option :value="false" label="Não"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="6">
                                <el-form-item label="Publica a lista (transparência)?">
                                    <el-select v-model="dados.publica_lista" style="width: 100%;">
                                        <el-option :value="false" label="Não"></el-option>
                                        <el-option :value="true" label="Sim — página pública"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Turnos elegíveis">
                                    <el-select v-model="dados.turnos" multiple style="width: 100%;">
                                        <el-option v-for="t in turnos" :key="t.v" :value="t.v" :label="t.l"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-alert v-if="dados.publica_lista" type="warning" :closable="false"
                            title="A lista pública exibe apenas posição, protocolo, nome com iniciais e data. Nenhum dado de contato é publicado."></el-alert>
                    </el-form>
                </el-tab-pane>

                <el-tab-pane label="Escolas participantes" name="escolas">
                    <el-alert type="info" :closable="false" show-icon class="u-mb-15"
                        title="Selecione as escolas que participam deste processo."
                        description="Só as escolas participantes aparecem para o candidato escolher na inscrição."></el-alert>

                    <el-transfer v-model="dados.instituicoes" :data="opcoesEscolas" filterable
                        :titles="['Disponíveis', 'Participantes']" :props="{ key: 'key', label: 'label' }"
                        filter-placeholder="Buscar escola pelo nome..."
                        class="transfer-escolas"></el-transfer>
                </el-tab-pane>

                <el-tab-pane label="Critérios de classificação" name="criterios">
                    <el-alert type="info" :closable="false" class="u-mb-15"
                        title="A pontuação é somada automaticamente. A ordem de desempate define quem vem antes em caso de empate; o último desempate é sempre a data da inscrição."></el-alert>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 170px;">Critério</th>
                                    <th style="width: 110px;">Origem</th>
                                    <th style="width: 150px;">Campo</th>
                                    <th style="width: 110px;">Operador</th>
                                    <th style="width: 110px;">Valor</th>
                                    <th style="width: 80px;">Pontos</th>
                                    <th style="width: 90px;">Desempate</th>
                                    <th style="width: 60px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, idx) in criterios" :key="idx">
                                    <td><el-input v-model="c.nome" size="mini"></el-input></td>
                                    <td>
                                        <el-select v-model="c.origem" size="mini" style="width: 100%;">
                                            <el-option value="formulario" label="Formulário"></el-option>
                                            <el-option value="cadastro" label="Cadastro"></el-option>
                                        </el-select>
                                    </td>
                                    <td><el-input v-model="c.campo_origem" size="mini" placeholder="ex.: bolsa_familia"></el-input></td>
                                    <td>
                                        <el-select v-model="c.operador" size="mini" style="width: 100%;">
                                            <el-option v-for="o in operadores" :key="o" :value="o" :label="o"></el-option>
                                        </el-select>
                                    </td>
                                    <td><el-input v-model="c.valor_comparacao" size="mini"></el-input></td>
                                    <td><el-input v-model="c.pontos" size="mini"></el-input></td>
                                    <td><el-input v-model="c.ordem_desempate" v-mask="'##'" size="mini"></el-input></td>
                                    <td class="u-text-center">
                                        <el-button @click="criterios.splice(idx, 1)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                    </td>
                                </tr>
                                <tr v-if="criterios.length === 0"><td colspan="8" class="u-text-center">Nenhum critério.</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <el-button size="mini" icon="el-icon-plus" class="u-mt-10" @click="addCriterio">ADICIONAR CRITÉRIO</el-button>
                    <el-button v-if="podeEscrever" size="mini" type="primary" class="u-mt-10 u-ml-10" @click="salvarCriterios" :disabled="!modoEdicao">SALVAR CRITÉRIOS</el-button>
                    <small v-if="!modoEdicao" class="u-ml-10">Salve o processo primeiro para cadastrar os critérios.</small>
                </el-tab-pane>

                <el-tab-pane label="Formulário do candidato" name="formulario">
                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 160px;">Chave</th>
                                    <th>Rótulo</th>
                                    <th style="width: 130px;">Tipo</th>
                                    <th style="width: 110px;" class="u-text-center">Obrigatório</th>
                                    <th style="width: 60px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, idx) in campos" :key="idx">
                                    <td><el-input v-model="c.chave" size="mini" placeholder="bolsa_familia"></el-input></td>
                                    <td><el-input v-model="c.label" size="mini"></el-input></td>
                                    <td>
                                        <el-select v-model="c.tipo" size="mini" style="width: 100%;">
                                            <el-option value="text" label="Texto"></el-option>
                                            <el-option value="number" label="Número"></el-option>
                                            <el-option value="boolean" label="Sim/Não"></el-option>
                                            <el-option value="date" label="Data"></el-option>
                                        </el-select>
                                    </td>
                                    <td class="u-text-center"><el-checkbox v-model="c.obrigatorio"></el-checkbox></td>
                                    <td class="u-text-center">
                                        <el-button @click="campos.splice(idx, 1)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                    </td>
                                </tr>
                                <tr v-if="campos.length === 0"><td colspan="5" class="u-text-center">Nenhum campo.</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <el-button size="mini" icon="el-icon-plus" class="u-mt-10" @click="campos.push({ chave: '', label: '', tipo: 'text', obrigatorio: false })">ADICIONAR CAMPO</el-button>
                </el-tab-pane>
            </el-tabs>

            <div class="u-text-right u-mt-20" v-if="carregado">
                <router-link to="/admin/processo-inscricao"><el-button>CANCELAR</el-button></router-link>
                <el-button class="u-ml-10" v-if="podeEscrever" type="primary" @click="salvar">SALVAR PROCESSO</el-button>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO D — itens 45, 60, 61 e 117. Interface para `api/processo-inscricao`. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        carregado: false, aba: 'diretrizes',
        opcoesEscolas: [], operadores: [],
        criterios: [], campos: [],
        turnos: [{ v: 0, l: 'Matutino' }, { v: 1, l: 'Vespertino' }, { v: 2, l: 'Noturno' }, { v: 4, l: 'Integral' }],
        dados: {
            nome: '', tipo: 'lista_espera', periodo_letivo_id: null, data_inicio: '', data_fim: '',
            qtd_max_estabelecimentos: 1, canal: 'ambos', publica_resultado: true, publica_lista: false,
            situacao: true, instituicoes: [], turnos: [], modalidades: [], niveis_escolares: [],
            campos_formulario: []
        }
    }),
    computed: {
        /**
         * Esconder o botão NÃO é segurança — o backend continua sendo a autoridade.
         * Isso só evita oferecer ao perfil Consulta uma ação que a API vai recusar.
         */
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
 modoEdicao () { return !!this.$route.params.id } },
    mounted () {
        this.dados.periodo_letivo_id = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/processo-inscricao/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.operadores = (r.data && r.data.operadores) ? r.data.operadores : [] }).catch(() => {})

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            this.opcoesEscolas = (Array.isArray(r.data) ? r.data : []).map(i => ({ key: i.id, label: i.nome }))
        }).catch(() => {})

        if (this.modoEdicao) this.carregarRegistro()
        else this.carregado = true
    },
    methods: {
        carregarRegistro () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/processo-inscricao/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/processo-inscricao')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
                this.dados.data_inicio = String(reg.data_inicio || '').substring(0, 10)
                this.dados.data_fim = String(reg.data_fim || '').substring(0, 10)
                this.dados.instituicoes = (reg.instituicoes || []).map(i => i.id)
                this.criterios = reg.criterios || []
                this.campos = reg.campos_formulario || []
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        addCriterio () {
            this.criterios.push({ nome: '', origem: 'formulario', campo_origem: '', operador: 'igual',
                valor_comparacao: '', pontos: 0, ordem_desempate: null, situacao: true })
        },
        salvar () {
            window.eventBus.$emit('loading', true)
            const payload = Object.assign({}, this.dados, { campos_formulario: this.campos })
            const url = this.modoEdicao
                ? `${this.$store.state.config.baseUrlApi}/api/processo-inscricao/update/${this.$route.params.id}`
                : `${this.$store.state.config.baseUrlApi}/api/processo-inscricao/store`

            this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Processo salvo.', type: 'success' })
                this.$router.push('/admin/processo-inscricao')
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        salvarCriterios () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/processo-inscricao/criterios/salvarLote`,
                { processo_inscricao_id: this.$route.params.id, itens: this.criterios },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
            }).catch(e => this.$store.commit('throwException', e))
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>

<style scoped>
/*
    O `el-transfer` do Element tem painel de LARGURA FIXA (200px) e altura de 246px.
    `style="width:100%"` no componente não muda isso — a largura está no painel interno,
    e com nome de escola municipal ("CENTRO MUNICIPAL DE EDUCAÇÃO INFANTIL ...") o rótulo
    fica cortado num prefixo comum a dezenas de unidades, tornando a lista inútil.

    Aqui o container vira flex e os painéis dividem a largura disponível.
*/
.transfer-escolas ::v-deep .el-transfer-panel {
    width: auto;
    flex: 1 1 0;
    min-width: 0;          /* sem isto o flex item não encolhe e volta a estourar */
}

.transfer-escolas {
    display: flex;
    align-items: center;
}

.transfer-escolas ::v-deep .el-transfer__buttons {
    flex: 0 0 auto;
    padding: 0 16px;
}

/* 147 escolas numa caixa de 246px obriga a rolar demais para achar uma. */
.transfer-escolas ::v-deep .el-transfer-panel__body,
.transfer-escolas ::v-deep .el-transfer-panel__list {
    height: 380px;
}

.transfer-escolas ::v-deep .el-transfer-panel__list.is-filterable {
    height: 330px;
}

/*
    O rótulo do Element é `display:block` com `text-overflow:ellipsis`, o que corta o nome
    mesmo quando há espaço. Deixando quebrar em duas linhas, o nome inteiro aparece.
*/
.transfer-escolas ::v-deep .el-transfer-panel__item {
    display: block;
    height: auto;
    line-height: 1.45;
    /*
        Element aplica o recuo lateral no próprio item. Zerar o padding para ganhar altura
        colava a caixa de seleção na borda do painel — daí o recuo explícito aqui.
    */
    padding: 4px 15px 4px 14px;
}

/*
    A LUPA DO FILTRO.

    `public/public/style.css` aplica `padding: 0 !important` em TODO `.el-input__inner`
    (é o estilo de campo sublinhado do projeto). Com isso o ícone de prefixo do Element
    fica por cima do texto do placeholder, em vez de ao lado dele. O projeto já resolve
    isso pontualmente onde precisa — o date-picker recompõe o `padding-left`.

    Aqui o ícone vai para o fim do campo: numa entrada sublinhada, o canto direito é onde
    ele não compete com o texto digitado.
*/
.transfer-escolas ::v-deep .el-transfer-panel__filter .el-input__prefix {
    left: auto;
    right: 0;
}

.transfer-escolas ::v-deep .el-transfer-panel__filter .el-input__inner {
    padding-right: 22px !important;
}

.transfer-escolas ::v-deep .el-transfer-panel__item .el-checkbox__label {
    white-space: normal;
    word-break: break-word;
    overflow: visible;
    text-overflow: clip;
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 24px);
}

@media (max-width: 768px) {
    .transfer-escolas { flex-direction: column; }
    .transfer-escolas ::v-deep .el-transfer-panel { width: 100%; flex: none; }
    .transfer-escolas ::v-deep .el-transfer__buttons { padding: 12px 0; transform: rotate(90deg); }
}
</style>
